"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ActionTypes = _interopRequireDefault(require("composer-lib/redux/ActionTypes"));

var _immutable = require("immutable");

var _uniqueId = _interopRequireDefault(require("transmute/uniqueId"));

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.OrderedMap();
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var data = action.data;

  switch (action.type) {
    case _ActionTypes.default.ADD_TOAST:
      {
        var uniqueKey = data.get('key') || (0, _uniqueId.default)('toast_');
        return state.set(uniqueKey, data);
      }

    case _ActionTypes.default.REMOVE_TOAST:
      return state.delete(data);

    default:
      return state;
  }
};

exports.default = _default;
module.exports = exports.default;